import { NativeModule } from "expo";

import type {
  CarCatalog,
  CarModuleEvents,
  CarPlaybackDescriptor,
  CarPlaybackStatus,
  CarPlayRequest,
  CarSearchResults,
} from "$src/core/services/car/types";

/** No-op fallback for every platform other than Android. */
class ExpoAndroidAutoModule extends NativeModule<CarModuleEvents> {
  async setCatalogAsync(_: CarCatalog): Promise<void> {
    // noop
  }

  async setSearchResultsAsync(_: CarSearchResults): Promise<void> {
    // noop
  }

  async setPlaybackAsync(_: CarPlaybackDescriptor | null): Promise<void> {
    // noop
  }

  async consumePendingPlayAsync(): Promise<CarPlayRequest | null> {
    return null;
  }

  isConnected(): boolean {
    return false;
  }

  async getPlaybackStatusAsync(): Promise<CarPlaybackStatus> {
    return { state: "stopped", position: 0 };
  }

  async togglePlayPauseAsync(): Promise<void> {
    // noop
  }

  async seekByAsync(_: number): Promise<void> {
    // noop
  }
}

export default new ExpoAndroidAutoModule();
